// removed by extract-text-webpack-plugin
module.exports = {"container":"medium-comments__container__KLwa0","comments-container":"medium-comments__comments-container__lidm9","likes":"medium-comments__likes__orVD9","heart-icon":"medium-comments__heart-icon__gESTl","user-name":"medium-comments__user-name__12KKc","comments-list":"medium-comments__comments-list__3olxi","comment":"medium-comments__comment__2kq1S","comment-meta":"medium-comments__comment-meta__hDmft","inline-loading-indicator":"medium-comments__inline-loading-indicator__1H_YZ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/media/medium-comments.scss
// module id = 1428
// module chunks = 1